import React from 'react';
import LiveCoachingActions from 'actions/scorecards/LiveCoachingActions';
import './GeneralComments.styl';
import RichTextEditor, {
  RichText,
} from 'components/pure/utils/form/user-taggable-input/RichTextEditor';
import EditIcon from 'components/pure/utils/icon/EditIcon';
import CoachingReviewActions from 'actions/coaching/CoachingReviewActions';
import Button from '@material-ui/core/Button';
import {List} from 'immutable';

export default class GeneralComments extends React.Component {
  constructor(props) {
    super(props);

    this.onChange = this.onChange.bind(this);
    this.setEditing = this.setEditing.bind(this);
    this.updateComment = this.updateComment.bind(this);
    this.state = {isEditing: false};
  }

  onChange(c) {
    LiveCoachingActions.setGeneralComments(c);
  }

  setEditing() {
    this.setState({isEditing: true});
  }

  // Update the comment on an already saved live coaching review file upload
  // NOT used for the initial live coaching flow, only edits.
  async updateComment() {
    const {reviewFileUpload, generalComments, reviewId} = this.props;

    try {
      await CoachingReviewActions.updateReviewFileUploads(
        reviewId,
        List([reviewFileUpload.set('comment', generalComments)])
      );
      this.setState({isEditing: false});
    } catch (e) {
      console.error(e);
    }
  }

  render() {
    const {generalComments, reviewFileUpload, reviewId} = this.props;
    const isEditing = this.state.isEditing || this.props.isEditing;
    const hasReviewData = reviewFileUpload && reviewId;

    // If this is explicitly editable, don't allow toggle
    const showEditButton = hasReviewData && !this.props.isEditing;

    // If we don't have the review data we can't save
    // also don't show save if editable via prop. Parent takes care of
    // submission in this case
    const showSaveButton = hasReviewData && this.state.isEditing;

    return (
      <div className="general-comments-wrapper">
        <div className="general-comments-header">
          <h3>Live Coaching General Comments</h3>
          {showEditButton && <EditIcon onClick={this.setEditing} />}
        </div>
        {isEditing ? (
          <RichTextEditor
            className="general-comments"
            onChange={this.onChange}
            value={generalComments}
          />
        ) : (
          <RichText dangerousText={generalComments || ''} />
        )}
        {showSaveButton && (
          <div className="button-wrapper">
            <Button
              variant="contained"
              color="primary"
              className="ev-button"
              onClick={this.updateComment}>
              Save
            </Button>
            <Button
              variant="outlined"
              className="ev-button"
              onClick={() => this.setState({isEditing: false})}>
              Cancel
            </Button>
          </div>
        )}
      </div>
    );
  }
}
